<template>
  <section class="users-page">
    <div class="header">
      <div class="header-body">
        <div class="row align-items-end">
          <div class="col">
            <h1 class="header-title">
              Users
            </h1>
          </div>
          <div class="col-auto">
            <b-button variant="success" @click="AddItem">
              <i class="fa fa-plus mr-2"></i>
              Add New
            </b-button>
          </div>
        </div>
      </div>
    </div>

    <div class="d-flex">
      <!-- The modal -->
      <b-form @submit="SaveItem">
        <b-modal
          id="changeItem"
          v-model="showModalChange"
          :centered="true"
          size="lg"
          title="User Form"
        >
          <b-form-group label="Email:">
            <b-form-input v-model="itemChange.email" required />
          </b-form-group>
          <b-row>
            <b-form-group class="col-12 col-md-6" label="First Name:">
              <b-form-input v-model="itemChange.firstName" required />
            </b-form-group>
            <b-form-group class="col-12 col-md-6" label="Last Name:">
              <b-form-input v-model="itemChange.lastName" required />
            </b-form-group>
            <b-form-group
              v-if="!editMode"
              class="col-12 col-md-6"
              label="Password:"
            >
              <b-form-input v-model="itemChange.password" type="password" />
            </b-form-group>
            <b-form-group
              v-if="!editMode"
              class="col-12 col-md-6"
              label="Confirm Password:"
            >
              <b-form-input
                v-model="itemChange.confirmPassword"
                type="password"
              />
            </b-form-group>
            <b-form-group class="col-12 col-md-6" label="Main Role:" v-if="$store.getters['account/hasUserRole']('superadmin')">
              <b-form-select v-model="itemChange.roleType">
                <option value="end-user">
                  Client
                </option>
                <option value="admin">
                  Admin
                </option>
              </b-form-select>
            </b-form-group>


            <b-form-group
              class="col-12"
              label="Access To Projects:"
            >
              <div class="multicheckbox border">
                <label
                  v-for="itm in projectPickfrom"
                  :key="itm.value"
                  :for="'projItem-' + itm.value"
                  class="multicheckbox-item"
                >
                  <input
                    :id="'projItem-' + itm.value"
                    v-model="itemChange.accessProjectsIds"
                    type="checkbox"
                    class="d-none"
                    :name="'projItem-' + itm.value"
                    :value="itm.value"
                  />
                  <span>{{ itm.text }}</span>
                </label>
              </div>
            </b-form-group>
            <div class="col-12">
              <b-form-group label="Additional Permissions">
                <b-form-checkbox-group
                  v-model="itemChange.moreRoles"
                  :options="possibleMoreRoles"
                  name="check-button"
                  switch
                ></b-form-checkbox-group>
              </b-form-group>
            </div>

            <!-- <b-form-group class="col-12 col-md-6" label="Permissions:">
                <div class="multicheckbox">
                  <label v-for="itm in claimsListPos" :key="itm.value" :for="'conClaim-'+itm.value" class="multicheckbox-item">
                    <input type="checkbox" class="d-none" :id="'conClaim-'+itm.value" name="conClaimPicked" :value="itm.value" :disabled="itm.disabled ? true : false" v-model="itemChange.userClaims" />
                    <span>{{itm.text}}</span>
                  </label>
                </div>
              </b-form-group>-->
          </b-row>

          <template v-slot:modal-footer>
            <b-button
              type="reset"
              variant="outline-secondary"
              class="mr-2"
              @click="showModalChange = false"
            >
              Cancel
            </b-button>
            <b-button type="submit" variant="primary" @click="SaveItem()">
              Save User
            </b-button>
          </template>
        </b-modal>
      </b-form>
    </div>

    <b-tabs>
      <b-tab class="p-0" title="Admins" v-if="$store.getters['account/hasUserRole']('superadmin')" active>
        <b-table
          head-variant="dark"
          responsive
          :items="logisticUsers"
          :fields="fields"
          hover
          striped
          fixed
        >
          <template v-slot:cell(id)="data">
            <div class="d-flex">
              <button
                class="btn btn-secondary mr-2"
                @click="EditItem(data.item)"
              >
                Edit
              </button>
              <button
                v-if="!data.item.userRoles.includes('superadmin')"
                class="btn btn-primary"
                @click="DeleteItem(data.item.id)"
              >
                Delete
              </button>
              <button
                v-else
                title="Can't Delete SuperAdmins"
                disabled="disabled"
                class="btn btn-primary disabled"
              >
                Delete
              </button>
            </div>
          </template>
          <template v-slot:cell(createDateTimeUtc)="data">
            <span
              v-b-tooltip.hover
              :title="
                'Last Active: ' +
                  fromNowDate(data.item.lastLoginDateTimeUtc) +
                  ', or: ' +
                  fullHumanDate(
                    data.item.lastLoginDateTimeUtc,
                    'MMMM Do, YYYY hh:mm:ss'
                  )
              "
              >{{
                data.item.createDateTimeUtc | moment('MMMM Do YYYY h:mm a')
              }}</span
            >
          </template>
          <template v-slot:cell(userRoles)="data">
            <span v-if="data.item.userRoles.includes('superadmin')"
              >SuperAdmin</span
            >
            <span v-else-if="data.item.userRoles.includes('admin')"
              >Admin</span
            >
          </template>
        </b-table>
      </b-tab>

      <b-tab class="p-0" title="End Users" :active="!$store.getters['account/hasUserRole']('superadmin')">
        <b-table
          head-variant="dark"
          responsive
          :items="endUsers"
          :fields="fields"
          hover
          striped
          fixed
        >
          <template v-slot:cell(id)="data">
            <div class="d-flex">
              <button
                class="btn btn-secondary mr-2"
                @click="EditItem(data.item)"
              >
                Edit
              </button>
              <button
                v-if="!data.item.userRoles.includes('superadmin')"
                class="btn btn-primary"
                @click="DeleteItem(data.item.id)"
              >
                Delete
              </button>
              <button
                v-else
                title="Can't Delete SuperAdmins"
                disabled="disabled"
                class="btn btn-primary disabled"
              >
                Delete
              </button>
            </div>
          </template>
          <template v-slot:cell(createDateTimeUtc)="data">
            <span
              v-if="
                data.item.createDateTimeUtc &&
                  !data.item.createDateTimeUtc.endsWith('Z')
              "
              >{{
                (data.item.createDateTimeUtc + 'Z')
                  | moment('MMMM Do YYYY h:mm a')
              }}</span
            >
            <span v-else-if="data.item.createDateTimeUtc">{{
              data.item.createDateTimeUtc | moment('MMMM Do YYYY h:mm a')
            }}</span>
          </template>
          <template v-slot:cell(userRoles)>
            <span>End User</span>
          </template>
        </b-table>
      </b-tab>
    </b-tabs>
  </section>
</template>

<script>
import moment from 'moment-timezone';
import { myCommonDataMixin } from '@/helpers/utils/vueMixins.js';
export default {
  mixins: [myCommonDataMixin],
  name: 'Users',
  components: {},
  data() {
    return {
      projectsAll: [],
      editMode: false, // true if editing, false if adding
      possibleMoreRoles: [
        { text: 'Can View All Tickets', value: 'tickets-shared' },
      ],
      itemChange: {
        accessProjectsIds: [],
        userClaims: [],
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        newPassword: '',
        projectId: '',
        roleType: 'end-user',
        isManager: false
      },
      showModalChange: false,
      userList: [],
      fields: [
        { key: 'firstName', label: 'First Name', sortable: true },
        { key: 'lastName', label: 'Last Name', sortable: true },
        { key: 'email', label: 'Email', sortable: true },
        { key: 'userRoles', label: 'Role', sortable: true },
        { key: 'createDateTimeUtc', label: 'Registered At', sortable: true },
        { key: 'id', label: 'Action', sortable: false }
      ]
    };
  },
  computed: {
    projectPickfrom: {
      get() {
        let arrs = [];
        this.myProjects.forEach(itm => {
          arrs.push({ value: itm.id, text: itm.name });
        });
        return arrs;
      },
      set(old, val) {}
    },
    endUsers: {
      get() {
        return this.userList.filter(us => us.userRoles && us.userRoles.includes('end-user'));
      },
      set(old, val) {}
    },
    logisticUsers: {
      get() {
        return this.userList.filter(
          us =>
            us.userRoles && (
              us.userRoles.length < 1 ||
              us.userRoles.includes('admin') ||
              us.userRoles.includes('superadmin')
            )
        );
      },
      set(old, val) {}
    }
  },
  mounted() {
    this.loadUsers();
    //this.loadProjects();
  },
  methods: {
    fullHumanDate(date, str) {
      return moment
        .utc(date)
        .local()
        .format(str);
    },
    fromNowDate(date) {
      return moment
        .utc(date)
        .local()
        .fromNow();
    },
    loadProjects() {
      this.$http
        .get('/api/admin/projects')
        .then(resp => {
          this.projectsAll = resp.data;
        })
        .catch(err => {});
    },
    loadUsers() {
      this.$http
        .get('/api/admin/users')
        .then(resp => {
          this.userList = resp.data;
        })
        .catch(err => {});
    },
    OnReset() {
      //alert('form reset: ' + this.itemChange.name)
      this.itemChange = {
        accessProjectsIds: [],
        userClaims: [],
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        newPassword: '',
        projectId: '',
        roleType: 'end-user',
        isManager: false
      };
    },
    AddNewItem() {
      if(this.itemChange.accessProjectsIds != null && this.itemChange.accessProjectsIds.length>0) {
        this.$http
          .post('/api/admin/users', this.itemChange)
          .then(resp => {
            this.loadUsers();
          })
          .catch(err => {});
        this.showModalChange = false;
      } else {
        alert('You must assign at least one project to the user!')
      }
    },
    SaveChangedItem(user) {
      this.$http
        .put('/api/admin/users/' + user.id, user)
        .then(resp => {
          this.loadUsers();
        })
        .catch(err => {});
      this.showModalChange = false;
    },
    SaveItem() {
      if (this.editMode !== false) {
        let user = this.editMode;
        user.firstName = this.itemChange.firstName;
        user.lastName = this.itemChange.lastName;
        user.email = this.itemChange.email;
        user.accessProjectsIds = this.itemChange.accessProjectsIds;

        user.projectId = this.itemChange.projectId;
        user.userClaims = this.itemChange.userClaims;

        user.roleType = this.itemChange.roleType;
        user.moreRoles = this.itemChange.moreRoles;
        this.SaveChangedItem(user);
      } else {
        if (!this.itemChange.roleType) {
          alert('You must pick a Client!');
          return;
        }
        this.AddNewItem();
      }
    },
    AddItem(id) {
      this.editMode = false;
      this.OnReset();

      this.showModalChange = true;
    },
    EditItem(user) {
      this.editMode = user;
      this.itemChange.lastName = user.lastName;
      this.itemChange.firstName = user.firstName;
      this.itemChange.userClaims = [];
      this.itemChange.email = user.email;
      this.itemChange.moreRoles = user.userRoles;
      if (user.accessProjectsIds) {
        this.itemChange.accessProjectsIds = user.accessProjectsIds;
      } else {
        this.itemChange.accessProjectsIds = [];
      }

      if (user.userRoles) {
        if (user.userRoles.includes('admin')) {
          this.itemChange.roleType = 'admin';
        } else if (user.userRoles.includes('end-user')) {
          this.itemChange.roleType = 'end-user';
        }
      } else {
        this.itemChange.roleType = '';
      }
      this.showModalChange = true;
    },
    DeleteItem(id) {
      this.$http
        .delete('/api/admin/users/' + id)
        .then(resp => {
          this.userList = this.userList.filter(s => s.id != id);
        })
        .catch(err => {});
    }
  }
};
</script>
